<div class="main-content table-page table-page--compact table-page--dense mi-asistencia-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Mi asistencia</h1>
        <p>{{ subtitulo }}</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="hoy()">
          <span class="material-icons">today</span>
          Hoy
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Día</mat-label>
              <input matInput aria-label="Día" [matDatepicker]="diaPicker" [(ngModel)]="fecha" />
              <mat-datepicker-toggle matIconSuffix [for]="diaPicker"></mat-datepicker-toggle>
              <mat-datepicker #diaPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar()">
            <span class="material-icons">search</span>
            Consultar
          </button>
        </div>
      </div>

      <div class="mi-asistencia-page__resumen" *ngIf="dia && !loading">
        <!-- Sin veredicto (la empresa no lo muestra) no hay etiqueta: una
             vacia saldria como "-", que parece un error. Las horas de abajo
             se quedan. -->
        <div class="mi-asistencia-page__veredicto" *ngIf="veredictoVisible">
          <span [class]="claseEstatus(dia.estatus)">{{ etiquetaEstatus(dia.estatus) }}</span>
          <p class="mi-asistencia-page__mensaje" *ngIf="dia.mensaje">{{ dia.mensaje }}</p>
        </div>

        <dl class="mi-asistencia-page__datos">
          <div>
            <dt>Entrada esperada</dt>
            <dd>{{ soloHora(dia.horaEsperadaEntrada) || "Sin horario" }}</dd>
          </div>
          <div>
            <dt>Entrada registrada</dt>
            <dd>{{ soloHora(dia.horaEntradaReal) || "Sin registro" }}</dd>
          </div>
          <div>
            <dt>Salida registrada</dt>
            <dd>{{ soloHora(dia.horaSalidaReal) || "Sin registro" }}</dd>
          </div>
          <div>
            <dt>Tiempo trabajado</dt>
            <dd>{{ horasTrabajadas }}</dd>
          </div>
          <div>
            <dt>Modalidad del día</dt>
            <dd>{{ etiquetaModalidad() }}</dd>
          </div>
          <div *ngIf="mostrarRetardo">
            <dt>Retardo</dt>
            <dd>{{ dia.minutosRetardo }} min</dd>
          </div>
        </dl>
      </div>

      <div class="table-page__empty" *ngIf="!dia && !loading">
        <span class="material-icons">event_note</span>
        <h3>No hay información de ese día</h3>
        <p>Elija otra fecha, o revise con su supervisor si esperaba tener horario asignado.</p>
      </div>

      <div class="table-page__empty table-page__empty--loading" *ngIf="loading">
        <span class="material-icons">hourglass_top</span>
        <h3>Consultando su día</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card mi-asistencia-page__equipos">
      <div class="table-page__toolbar">
        <div class="table-page__copy">
          <h2>Mis equipos</h2>
          <p>Los teléfonos desde los que puede registrar; se dan de alta desde la app.</p>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="dispositivos.length > 0; else sinEquipos">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Equipo</th>
              <th>Sistema</th>
              <th>Estatus</th>
              <th>Última verificación</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let equipo of dispositivos">
              <td><span class="table-page__text">{{ equipo.modelo || "Sin modelo" }}</span></td>
              <td><span class="table-page__text">{{ equipo.plataforma }}</span></td>
              <td>
                <span class="table-page__status-badge"
                      [class.is-active]="equipo.estatus === 'ACTIVO'"
                      [class.is-pending]="equipo.estatus === 'PENDIENTE'"
                      [class.is-inactive]="equipo.estatus === 'REVOCADO'">
                  {{ etiquetaEstatusDispositivo(equipo.estatus) }}
                </span>
              </td>
              <td><span class="table-page__text">{{ soloFecha(equipo.ultimaVerificacion) || "Nunca" }}</span></td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                        title="Desvincular" aria-label="Desvincular"
                        *ngIf="equipo.estatus !== 'REVOCADO'"
                        (click)="revocarDispositivo(equipo)">
                  <span class="material-icons">link_off</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #sinEquipos>
        <div class="table-page__empty">
          <span class="material-icons">smartphone</span>
          <h3>No tiene equipos vinculados</h3>
          <p>Instale la app y vincule su teléfono para poder registrar desde fuera de la oficina.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
